import type { TFunction } from 'i18next';
import { getMetadataString } from '../helpers/purchase-order-activity-metadata';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';
import { PurchaseOrderActivityDocumentBadge } from './purchase-order-activity-document-badge';

type PurchaseOrderActivityDocumentUploadedProps = {
  activity: PurchaseOrderActivityItem;
  documentUrlByName: Record<string, string>;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityDocumentUploaded({
  activity,
  documentUrlByName,
  t,
}: PurchaseOrderActivityDocumentUploadedProps) {
  const documentName = getMetadataString(activity.metadata, 'documentName');
  const documentUrl = documentName ? documentUrlByName[documentName] : null;
  const documentTypeCode = getMetadataString(
    activity.metadata,
    'documentTypeCode',
  );

  return (
    <>
      <span className='font-semibold text-foreground'>
        {t('activity.document.uploaded')}
      </span>
      {documentName ? (
        documentUrl ? (
          <a
            className='font-semibold text-primary underline underline-offset-2'
            href={documentUrl}
            rel='noopener noreferrer'
            target='_blank'
          >
            {documentName}
          </a>
        ) : (
          <span className='font-semibold text-primary underline underline-offset-2'>
            {documentName}
          </span>
        )
      ) : null}
      {documentTypeCode ? (
        <PurchaseOrderActivityDocumentBadge
          documentTypeCode={documentTypeCode}
        />
      ) : null}
    </>
  );
}
